import * as dat from 'dat.gui';
import ShortcutTriggers from 'app/shortcuts/ShortcutTriggers';

export class ShortcutStub {
  constructor() {}
  reset() {}
  addLevelData() {}
  showLevelSettings() {}
}

const TRIGGER = '↑ ↑ ↓ ↓ ← →';

export default class Shortcuts {
  constructor(game, { model: shortcutsModel, isVisible: isVisible = false }) {
    this.game = game;
    this.model = shortcutsModel;

    this.gameSettings = null;
    this.levelSettings = null;

    this.hideSettingsControl = null;
    this.currentLevelControl = null;
    this.seasonUnlockedControl = null;
    this.cutscenesEnabledControl = null;
    this.countdownEnabledControl = null;

    this.soundControl = null;
    this.sfxControl = null;
    this.musicControl = null;
    this.voControl = null;
    this.captionsControl = null;

    this.levelSelectControl = null;
    this.nextLevelControl = null;
    this.boundHide = this.hide.bind(this);

    this.boundToggle = this.toggleDisplay.bind(this);
    this.boundLevelSelect = this.onLevelSelect.bind(this);
    this.boundNextLevel = this.onNextLevel.bind(this);

    this.boundToggleSound = this.toggleSound.bind(this);
    this.boundToggleSFX = this.toggleSFX.bind(this);
    this.boundToggleMusic = this.toggleMusic.bind(this);
    this.boundToggleVO = this.toggleVO.bind(this);
    this.boundToggleCaptions = this.toggleCaptions.bind(this);

    this.isVisible = isVisible;

    this.trigger = new ShortcutTriggers({
      sequence: TRIGGER,
      onComplete: this.boundToggle,
      // onFail: (val) => {
      //   console.log('FAIL', val);
      // },
    });
  }

  toggleDisplay() {
    this.isVisible ? this.hide() : this.show();
  }

  toggleSound() {
    this.game.sounds.soundVolume = this.model.sound ? 1 : 0;
  }
  toggleSFX() {
    this.game.sounds.sfxVolume = this.model.sfx ? 1 : 0;
  }
  toggleMusic() {
    this.game.sounds.musicVolume = this.model.music ? 1 : 0;
  }
  toggleVO() {
    this.game.sounds.voVolume = this.model.vo ? 1 : 0;
  }
  toggleCaptions() {
    this.game.springRollCaptionsPlugin.setMute(!this.model.captions);
  }

  open() {
    this.gui.open();
  }

  close() {
    this.gui.close();
  }

  show() {
    this.isVisible = true;
    this.gui.show();
  }

  hide() {
    this.isVisible = false;
    this.gui.hide();
  }

  setVisible() {
    this.isVisible ? this.show() : this.hide();
  }

  /*
  =========================================================================================================
    GAME
  =========================================================================================================
  */
  createGameSettings() {
    this.gameSettings = this.gui.addFolder('Game Settings');

    this.hideSettingsControl = this.gameSettings
      .add(this.model, 'hideShortcuts')
      .name('Hide Shortcuts')
      .onChange(this.boundHide);

    this.currentLevelControl = this.gameSettings
      .add(this.model, 'currentLevel')
      .name('Current Level');
    const el = this.currentLevelControl.domElement.getElementsByTagName('input')[0]; // make input read only
    el && (el.readOnly = true);

    this.seasonUnlockedControl = this.gameSettings
      .add(this.model, 'seasonsUnlocked')
      .name('Seasons unlocked [ TODO ]');

    this.cutscenesEnabledControl = this.gameSettings
      .add(this.model, 'cutscenesEnabled')
      .name('Play cutscenes');

    this.countdownEnabledControl = this.gameSettings
      .add(this.model, 'countdownEnabled')
      .name('Play countdown');

    this.gameSettings.open();
  }

  /*
  =========================================================================================================
    LEVELS
  =========================================================================================================
  */
  onNextLevel() {
    const levelId = this.game.controller.scNextLevel();
    console.log('onNextLevel', levelId);
  }
  onLevelSelect(value) {
    const levelID = Math.trunc(value.split('|')[0]);
    this.game.controller.scLaunchLevel({ levelID });
  }
  createLevelSettings() {
    this.levelSettings = this.gui.addFolder('Level Settings');

    this.levelSelectControl = this.levelSettings
      .add(this.model, 'launchLevel', this.levels)
      .name('Start level');
    this.levelSelectControl.setValue(this.levels[0]);
    this.levelSelectControl.onChange(this.boundLevelSelect);

    this.nextLevelControl = this.levelSettings
      .add(this.model, 'nextLevel')
      .name('Skip current level')
      .onChange(this.boundNextLevel);

    this.levelSettings.open();
  }

  /*
  =========================================================================================================
    AUDIO
  =========================================================================================================
  */
  createAudioSettings() {
    this.audioSettings = this.gui.addFolder('Audio');
    this.soundControl = this.audioSettings
      .add(this.model, 'sound')
      .name('Sound')
      .onChange(this.boundToggleSound);
    this.sfxControl = this.audioSettings
      .add(this.model, 'sfx')
      .name('SFX')
      .onChange(this.boundToggleSFX);
    this.musicControl = this.audioSettings
      .add(this.model, 'music')
      .name('Music')
      .onChange(this.boundToggleMusic);
    this.voControl = this.audioSettings
      .add(this.model, 'vo')
      .name('VO')
      .onChange(this.boundToggleVO);
    this.captionsControl = this.audioSettings
      .add(this.model, 'captions')
      .name('Captions')
      .onChange(this.boundToggleCaptions);
    // this.audioSettings.open();
  }

  /*
  =========================================================================================================
    API
  =========================================================================================================
  */
  create() {
    dat.GUI.TEXT_CLOSED = 'Close Shortcuts';
    dat.GUI.TEXT_OPEN = 'Open Shortcuts';
    this.gui = new dat.GUI({ name: 'Shortcuts', closed: false, autoPlace: false });
    this.gui.domElement.id = 'gui';
    document.getElementById('shortcuts-container').appendChild(this.gui.domElement);
    this.createGameSettings();
    this.createAudioSettings();
    this.close();
    this.hide();
  }

  reset() {
    this.model.currentLevel = 'none';
    this.currentLevelControl.updateDisplay();
    this.cleanUp(this.levelSelectControl);
    this.levelSettings && this.gui.removeFolder(this.levelSettings);
    this.levelSettings = null;
  }

  addLevelData({ levelData }) {
    this.levels = levelData.reduce((ary, item) => {
      ary.push(`${item.id} | ${item.description}`);
      return ary;
    }, []);
  }

  showLevelSettings({ level }) {
    this.model.currentLevel = this.levels[level];
    this.currentLevelControl.updateDisplay();
    if (!this.levelSettings) {
      this.createLevelSettings();
    } else {
      // update level select dropdown
      this.levelSelectControl.onChange(null);
      this.levelSelectControl.setValue(this.model.currentLevel);
      this.levelSelectControl.onChange(this.boundLevelSelect);
    }
  }

  cleanUp(control) {
    if (control) {
      control.remove();
      control = null;
    }
  }

  destroy() {
    this.boundHide = null;
    this.boundLevelSelect = null;
    this.boundNextLevel = null;

    this.cleanUp(this.hideSettingsControl);
    this.cleanUp(this.currentLevelControl);
    this.cleanUp(this.seasonUnlockedControl);
    this.cleanUp(this.cutscenesEnabledControl);
    this.cleanUp(this.countdownEnabledControl);
    this.gui.removeFolder(this.gameSettings);
    this.gameSettings = null;

    this.cleanUp(this.soundControl);
    this.cleanUp(this.sfxControl);
    this.cleanUp(this.musicControl);
    this.cleanUp(this.voControl);
    this.cleanUp(this.captionsControl);
    this.gui.removeFolder(this.audioSettings);
    this.audioSettings = null;

    this.cleanUp(this.levelSelectControl);
    this.cleanUp(this.nextLevelControl);
    this.gui.removeFolder(this.levelSettings);
    this.levelSettings = null;

    this.gui.destroy();
    this.gui = null;

    this.trigger.destroy();
    this.trigger = null;
  }
}
